/**
 * An app-relative href as the router wants it: the path, and the query string as the route's search
 * (`/t/demo/jobs/x/review?queue=review`). A `to` that still carries its `?…` matches no route.
 */
export function linkParts(href: string): { path: string; search?: Record<string, string> } {
  const [path = '/', query] = href.split('?', 2);
  return query ? { path, search: Object.fromEntries(new URLSearchParams(query)) } : { path };
}
